import { SeededRng } from '../../utils/SeededRng';

/** Deterministic per-channel random in [0, 1): `${seed}|${id}|${channel}`. */
export function rngFor(recipe: { seed: number; id: string }): (channel: string) => number {
  return (channel: string) => new SeededRng(`${recipe.seed}|${recipe.id}|${channel}`).next();
}

